import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submitbatch',
  templateUrl: './submitbatch.component.html',
  styleUrls: ['./submitbatch.component.css']
})
export class SubmitbatchComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }

  batchRequest = `
  curl --location 'https://api.optimusdrive.ai/v1/storage/batch' \ -H 'authorization: XXX' \ --data 
  '{ 
    "storage_type": "oci", 
    "paths": [ 
      "VideoForOptimizer/Bandtogether.mp4" 
    ], 
    "crunch_mode": "video_optimizer", 
    "process_type": "size" 
  }' 
  `

  batchResponse = `
  {
    "data":null,
    "message":"Batch request submitted successfully"
 }
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.batchRequest);
  }


}
